import { createAction } from 'typesafe-actions';

import { GeoValue } from 'shared/types/filters/geo';

export const changeGeoAction = createAction('filters/geoChanged')<GeoValue>();
